import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { VkMusicSuccessModalProps } from './VkMusicSuccessModal';

export const renderVkMusicSuccessModal = (data: VkMusicSuccessModalProps) => {
    openPopupHelper({
        popupName: popupNames.VK_MUSIC_SUCCESS_MODAL,
        data,
        onClose: data.onClose,
    });
};
